import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { LoggerService } from 'src/app/core/logger.service';
import { UserService } from 'src/app/core/user.service';
import { IErrorCode, IFile, IShareData, ISharememberData } from 'src/sync';
import { ShareService } from '../../../services/share.service';
import { FeedbackService } from 'src/app/notifications/feedback.service';
import { Button, ListItem } from '@material-library';
import { OrderByPipe } from 'src/app/shared/pipes/order-by.pipe';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { BlendEvent, SHARE_DETAILS_OPEN_STATE } from 'src/app/shared/models';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { ShareNewService } from 'src/app/shared/services/share-new.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BlendService } from 'src/app/shared/services/blend.service';
@Component({
  selector: 'app-share-member-list',
  templateUrl: './share-member-list.component.html',
  styleUrls: ['./share-member-list.component.scss']
})
export class ShareMemberListComponent implements OnInit, OnChanges {
  @Input() public shareData: IShareData;
  @Input() public openState: number;
  @Input() selected: IFile[] = [];

  @Input() showDialog!: boolean;
  @Output() showDialogChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() openStateChange: EventEmitter<number> = new EventEmitter();
  listItems: ListItem[] = [];

  public errors: Array<IErrorCode> = [];
  public spinner: boolean;
  public selectedPurge = true;
  public canChangeOwner = false;

  public predicate: string[] = ['isMe', 'displayname'];
  public isPro = false;
  public isVerified = false;
  public hasAppsNewFeature = false;

  public spinners = {
    member: 0,
  };
  public memberResent = 0;
  loading: boolean = false;
  sharedWithHeader = '';
  name: string = '';
  sectionHeaderButtonConfig!:Button
  public isSMScreen: boolean = false;
  private breakpointSubscription: Subscription;
  public avatarEndpoint = `${environment.logohost}avatar/saved/`;
  
  constructor(
    private loggerService: LoggerService,
    private userService: UserService,
    private shareService: ShareService,
    private Feedback: FeedbackService,
    private orderByPipe: OrderByPipe,
    private snackbarService: SnackbarService,
    public breakpointObserver: BreakpointObserver,
    private blendService: BlendService,
    private shareNewService: ShareNewService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.shareData && this.shareData) {
      this.updateButtonConfig();
    }
  }

  async ngOnInit() {
    this.showDialog = true;
    this.isVerified = this.userService.get('is_verified');
    this.hasAppsNewFeature = this.userService.get('new_feature');
    this.isPro = this.userService.get('is_pro');
    // await this.getShareDetails()
    if (!this.shareData) {
      this.loggerService.error(
        'Unable to find shareData for sharemember-list'
      );
      this.loggerService.error(
        JSON.parse(JSON.stringify(this.shareData))
      );
      this.errors.push({
        code: 9000,
        msg: 'No share member information provided',
      });
    }

    this.canChangeOwner = (this.shareData.people.filter(member => !(
      member.isMe ||
      ['Waiting Signup', 'Waiting'].includes(member.status)
    )).length > 0) && !!this.shareData.isOwner;

    const pending_users = this.shareData.people.filter((member) => {
      if (member.status === 'Confirm') {
        return member;
      }
    });

    if (pending_users.length > 0) {
      this.loggerService.info(`enc pending user found : ${pending_users.length}`);
      await this.shareNewService.postshareDataProcess(this.shareData.syncId);
      await this.updateUserStatus();
    }

    this.breakpointSubscription = this.breakpointObserver
    .observe(['(max-width: 905px)'])
    .subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isSMScreen = true;
      } else {
        this.isSMScreen = false;
      }
      this.generatePeopleList();
    });
    this.name = this.shareData['name'];
  }
  
  private updateButtonConfig(): void {
    if (this.shareData.isOwner) {
      this.sectionHeaderButtonConfig = {label: 'Add users', type: 'flat', color: 'default', size:'small', leadAdornment:true, leadIconAdornment:'user-add', onClick: this.onAddUsers};
    } else if (this.shareData.isInvite) {
      this.sectionHeaderButtonConfig = {label: 'Invite to share', type: 'flat', color: 'default', size:'small', leadAdornment:true, leadIconAdornment:'user-add', onClick: this.onAddUsers};
    }
  }

  ngOnDestroy(): void {
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
    }
  }

  public async updateUserStatus() {
    const share = await this.shareService.getShare(this.shareData.shareId);
    this.shareData = share;
  }

  public resendInvite = async (member: ISharememberData) => {
    try {
      this.errors = [];
      this.spinners.member = member.sharememberId;
      await this.shareService.resendInvite(this.shareData, member.email);
      this.spinners.member = 0;
      this.memberResent = member.sharememberId;
      // resent the invite, show success!
      this.snackbarService.showMessage('success', 'Invitation successfully sent.')
    } catch (err) {
      this.errors.push(err);
      this.snackbarService.showMessage('critical', 'Couldn’t complete action. Try again.')

    }
  }



  public getSelectedAmt(): number {
    let amt = 0;
    this.shareData.people.map((cur) => {
      if (cur.selected) {
        amt++;
      }
    });
    return amt;
  }

  private openPopup(state: number) {
    this.openStateChange.next(state);

  }

  closeDialog = (state: number = SHARE_DETAILS_OPEN_STATE.CLOSE_STATE) => {
    this.showDialog = false;

    setTimeout(() => {
      console.log('list', state,);
      this.showDialogChange.next(state > 0 ? true : false);
      this.openPopup(state)
    }, 50);
  }

  async getShareDetails() {
    this.loading = true;
    const share = this.selected;
    const webpath = Array.isArray(share) ? share[0] : share;
    const shareId = webpath.shareId || webpath.share_id;
    this.shareData = await this.shareService.getShare(shareId);
    this.loading = false;

  }

  generatePeopleList() {
    const listItems: ListItem[] = [];
    const peoples = this.shareData.people.sort((preMember, nextmember) => {
      const order = ['Owner', 'Active', 'Waiting', 'Waiting Signup', 'Declined', 'Quit'];
      const perStatus = preMember.permissions?.perOWNER ? 'Owner' : preMember.status
      const nextStatus = nextmember.permissions?.perOWNER ? 'Owner' : nextmember.status
      const preStatusInd = order.indexOf(perStatus);
      const nextStatusInd = order.indexOf(nextStatus);
      return preStatusInd - nextStatusInd;
    });
    peoples.forEach((member) => {
      let permissionStr = ``;
      let comma = '';
      member.selected = false;
      const permissions = member.permissions;
      if (permissions['perDOWNLOAD']) {
        permissionStr += 'View';
        comma = ', ';
      }
      if (permissions['perUPLOAD']) {
        permissionStr += comma + 'Edit';
      }
      if (permissions['perSEEOTHERS']) {
        permissionStr += comma + 'See others';
      }
      if (permissions['perINVITE']) {
        permissionStr += comma + 'Invite';
      }
      if (permissions['perADDAPP']) {
        permissionStr += comma + 'Add apps'
      }
      let item: ListItem;
      const actions = [];

      if (member.permissions.perOWNER) {//owner
        item = {
          primaryText: member.displayname, secondaryText: member.email, tertiaryText: permissionStr,
          trail1AdornmentConfig: {
            enabled: true, type: 'chip', size: 'large',
            chipConfig: {
              label: 'Owner', size: 'large', readOnly: true,
              leadAdornment: {
                enabled: true, type: 'icon', size: 'large',
                iconName: 'user-circle',
              }
            }
          },
        };
      } else {
        if ((member.status == 'Waiting' || member.status == 'Waiting Signup') && this.shareData.isOwner && this.memberResent != member.sharememberId) {
          actions.push({
            name: 'Resend invitation',
            icon: '',
            onClick: this.resendInvitation,
          },)
        }
        if (!member.permissions.perOWNER && this.shareData.isOwner && (member.user_status_id == 1 || member.user_status_id == -1)) {
          actions.push(
            {
              name: 'Edit permissions',
              icon: '',
              onClick: this.editPermissions,
            })
        }
        if (this.shareData.isOwner) {
          actions.push({
            name: 'Remove from shared folder',
            icon: '',
            onClick: this.removeFromShare,
          })
        }
        item = {
          primaryText: member.displayname, secondaryText: member.email, tertiaryText: permissionStr,
          trail1AdornmentConfig: {
            enabled: true, type: 'chip', size: 'large',
            chipConfig: {
              label: member.status, size: 'large', readOnly: true,
            }
          },
          showActions: !!actions.length,
          actionsConfig: {
            limit: 1,
            rowData: member,
            actions
          },
          // menuConfig: { enabled: true, type: 'iconButton', size: 'large', iconButtonConfig: { iconName: 'more-vertical', size: 'large' },}
        };
      };
      if(this.isSMScreen){
       delete item.trail1AdornmentConfig
      }
      item.leadAdornmentConfig= { 
        enabled: true, type: 'avatar', size: 'large',
        avatarConfig: { type: 'avatar', initials: member.displayname, url: `${this.avatarEndpoint}${member.userId}`, size:40, randomColor:true }
      }
      if(actions.length){
        item.isInteractive= true
      }
      listItems.push(item)
    });
    this.listItems = listItems;
    this.sharedWithHeader = `Shared with ${listItems.length} ${(listItems.length > 1) ? 'users' : 'user'}`;
  }
  onInviteShare = () => {

  }
  onAddUsers = () => {
    if (this.isVerified) {
      this.closeDialog(SHARE_DETAILS_OPEN_STATE.MEMBER_INVITE)
    } else {
      this.closeDialog(SHARE_DETAILS_OPEN_STATE.VERIFY_EMAIL)
    }
  }
  settings = () => {
    this.closeDialog(SHARE_DETAILS_OPEN_STATE.OPTIONS)
  }
  changeOwner = () => {
    this.closeDialog(SHARE_DETAILS_OPEN_STATE.CHOOSE_OWNER)

  }
  resendInvitation = (member: ISharememberData) => {
    this.resendInvite(member);
  }
  editPermissions = (member: ISharememberData) => {
    member.selected = true;
    this.closeDialog(SHARE_DETAILS_OPEN_STATE.MEMBER_PERMISSION)
  }
  removeFromShare = (member: ISharememberData) => {
    member.selected = true;
    this.closeDialog(SHARE_DETAILS_OPEN_STATE.MEMBER_REMOVE)
    this.blendService.track(BlendEvent.REMOVE_FROM_SHARE)
  }
  onLeave = () => {
    this.closeDialog(SHARE_DETAILS_OPEN_STATE.LEAVE_SHARE)
  }
}
